// extracted by mini-css-extract-plugin
module.exports = {"btn":"AmendDeviceContractForm_btn__NZ34w"};